import { API_INSTANCE, fullBuildURL } from 'src/features/utils';

export const fetchSelectedSiteApi = async () => {
  return await fetch(`${process.env.API_SERVICE_URL}/api/v1/accounts/select-site`, {
    method: 'POST',
    redirect: 'manual',
    credentials: 'include',
  });
};

export const fetchSideByIdApi = async (siteId: string) => {
  return await API_INSTANCE.get(fullBuildURL(`/api/v1/dashboard/sites/${siteId}`));
};
